// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "pages-DebugPage" + "-" + "c899626f428c018d664c" + ".css";
};